import { useSearchParams } from '@remix-run/react';

export const BOOST_AFFILIATE_COOKIE_NAME = 'bhba';
export const BOOST_AFFILIATE_ATTRIBUTION_WINDOW_DAYS = 0.17; // (~4 hours)

const useBoostAffiliate = (recommendingPublicationIdInCookie: string | undefined): string | undefined => {
  const [searchParams] = useSearchParams();

  const currentRecommendingPublicationId = searchParams.get('_bhba') || undefined;

  // If there's a cookie set for boosted publication
  // that is, the visitor came to this publication before
  // but via another affiliate link
  // then use the recommending publication id from that
  // affiliate link
  if (recommendingPublicationIdInCookie) {
    return recommendingPublicationIdInCookie;
  }

  // The visitor is visiting this publication first time
  // set cookie and attribute the subscription to
  // the recommending publication id in the url

  return currentRecommendingPublicationId;
};

export default useBoostAffiliate;
